// D5-2, THE FOURTH TIME, AND THIS IS THE ONE THAT MAKES IT STOP.
//
// The lesson has now cost four separate fixes in one round: the member detail rendered 13,233px
// below the fold; the support panel rendered at y=943 on an 852px screen; an opened reading rendered
// below a 25-row list; and then the usage page and the transcript rendered at top=-194, because the
// modal was still scrolled to where the PREVIOUS view had been left. Each time the code was correct
// and the answer was off-screen.
//
// The first three were fixed by structure (a modal, an order, a replacement). This one cannot be:
// swapping a tall view for a short one inside a scrolling panel leaves the scroll position behind by
// definition. So it is fixed by behaviour, ONCE, in a shared hook, rather than by three components
// each remembering to do it.
//
// ANY VIEW THAT REPLACES ANOTHER INSIDE THE DASHBOARD MODAL CALLS THIS. It is one line at the top of
// the component and a ref on its root, and it means a new surface added next year inherits the fix
// instead of rediscovering the bug.
import { useEffect, useRef } from "react";

export function useRevealHere<T extends HTMLElement>(deps: unknown[] = []) {
  const ref = useRef<T | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof el.scrollIntoView !== "function") return;
    // `block: "start"` and not "center": the top of a panel carries its heading and its way out, and
    // centering a tall view puts both above the fold — which is the bug wearing a different hat.
    el.scrollIntoView({ block: "start" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return ref;
}
